import { useEffect, useState } from 'react';
import { getBookingReasonDeclinedOptions } from '../requests/type-requests';

interface BookingReasonDeclinedOption {
  value: string;
  label: string;
}

/**
 * Hook to fetch and cache booking reason declined options
 * Returns a map of reason declined enum values to their descriptions
 */
export function useBookingReasonDeclinedOptions() {
  const [reasonDeclinedMap, setReasonDeclinedMap] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    getBookingReasonDeclinedOptions()
      .then(({ body }) => {
        const map: Record<string, string> = {};
        body.forEach((option: BookingReasonDeclinedOption) => {
          map[option.value] = option.label;
        });
        setReasonDeclinedMap(map);
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return { reasonDeclinedMap, loading, error };
}

